// extracted by mini-css-extract-plugin
export var footer = "Footer-module--footer--3mBiF";
export var footerMinContent = "Footer-module--footerMinContent--EsFHs";
export var footerMin = "Footer-module--footerMin--1ggUZ";
export var iconArrow = "Footer-module--iconArrow--3mCtW";
export var footerTop = "Footer-module--footerTop--Aucpm";
export var footer_listItem = "Footer-module--footer_listItem---Z8LW";
export var address = "Footer-module--address--1yVan";
export var footerCopyright = "Footer-module--footerCopyright--2qge0";
export var footerBottom = "Footer-module--footerBottom--3pMYV";
export var icon = "Footer-module--icon--2Lv8u";
export var img = "Footer-module--img--3JDv5";
export var pseudoIcon = "Footer-module--pseudoIcon--1wos6";
export var footerMinContentHeader = "Footer-module--footerMinContentHeader--17uuV";
export var footer_listItemMin = "Footer-module--footer_listItemMin--1w_Q8";